import React from 'react';
import { Card } from '../../../../components/tailgrids/core/card.js';

interface PanelHeaderProps {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({ title, subtitle, right }) => (
  <div className="flex items-start justify-between gap-3 border-b border-border px-4 py-2.5">
    <div>
      <div className="text-sm font-semibold text-heading">{title}</div>
      {subtitle && <div className="mt-0.5 text-xs text-muted">{subtitle}</div>}
    </div>
    {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
  </div>
);

export const Panel: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <Card className={`overflow-hidden p-0 ${className}`}>{children}</Card>
);
